export const blockIconsCommunicationMailNew = (
	<span className='material-symbols-outlined'>mail</span>
);
